const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  classes: [], // Liste des classes
  currentClass: null, // Classe sélectionnée
  loading: false,
  error: null,
  educators: [], // Liste des éducatrices
  childrenCount: 0 // Nombre d'enfants (peut être calculé)
};

const classSlice = createSlice({
  name: "class",
  initialState,
  reducers: {
    // Pour mettre à jour toute la liste des classes
    setClassesState: (state, { payload }) => {
      state.classes = payload;
    },
    // Pour modifier une classe spécifique
    setClassState: (state, { payload }) => {
      state.currentClass = payload;
    },
    // Pour ajouter/mettre à jour une classe
    upsertClassState: (state, { payload }) => {
      const index = state.classes.findIndex(c => c.id === payload.id);
      if(index >= 0) {
        state.classes[index] = payload;
      } else {
        state.classes.push(payload);
      }
    },
    // Pour gérer le chargement
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    // Pour gérer les erreurs
    setError: (state, { payload }) => {
      state.error = payload;
    },
    // Pour mettre à jour la liste des éducatrices
    setEducatorsState: (state, { payload }) => {
      state.educators = payload;
    },
    // Pour mettre à jour le compteur d'enfants
    updateChildrenCount: (state, { payload }) => {
      state.childrenCount = payload;
    },
    // Pour supprimer une classe
    removeClassState: (state, { payload }) => {
      state.classes = state.classes.filter(c => c.id !== payload);
    }
  },
});

// Export des actions
export const { 
  setClassesState,
  setClassState,
  upsertClassState,
  setLoading,
  setError,
  setEducatorsState,
  updateChildrenCount,
  removeClassState
} = classSlice.actions;

export default classSlice.reducer;